import { render, staticRenderFns } from "./PackageTypesRegistryList.vue?vue&type=template&id=49a7f1c6"
import script from "./PackageTypesRegistryList.vue?vue&type=script&lang=js"
export * from "./PackageTypesRegistryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports